import _ from 'underscore';
import http from './shared/http';

export const getCurrent = _.throttle(
  () =>
    http.get('/users/current').then(response => new User(response.data.user)),
  2000,
  { trailing: false }
);

export class User {
  constructor(data) {
    _.extend(this, data);
  }

  featureEnabled(feature) {
    return _.contains(this.enabled_features, feature);
  }

  isLoggedIn() {
    return !!this.id;
  }
}
